var React = require('react');

function Link (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1.3 6.16378L1.742 6.92934L5.54732 4.73234C5.31148 5.36387 5.15679 6.47393 5.16401 7.37043L6.03022 7.44075C6.04365 6.11202 6.28701 4.63553 6.76738 3.51756C5.55901 3.37459 4.16341 2.82934 2.98346 2.18961L2.61775 2.98618C3.41305 3.42768 4.44048 3.85525 5.10532 3.96678L1.3 6.16378Z","fill":"white"}));
}

Link.defaultProps = {"width":"9","height":"10","viewBox":"0 0 9 10","fill":"none"};

module.exports = Link;

Link.default = Link;
